import { RegionUpdatableInterface } from '../interfaces/region-updatable.interface';
import { PartialType, PickType } from '@nestjs/swagger';
import { RegionDto } from './region.dto';

export class RegionUpdateDto
  extends PartialType(
    PickType(RegionDto, [
      'name',
      'archived',
      'allowPayoutAmountEditing',
      'repairsRate',
      'garageCostFixed',
      'specialJobsPercentage',
      'dwHangingCostPerBoard',
      'dwFinishingCostPerBoard',
      'dwSprayingCostPerBoard',
      'pieceworkPercentage',
      'highCeilingPerBoard',
      'screwInspectionPerBoard',
      'phaseStructureType',
      'dwpHangingCostPerBoard',
      'dwpFinishCostPerBoard',
      'dwpPrimeCostPerSqft',
      'dwpBump1CostPerBoard',
      'dwpTrim1CostPerSqft',
      'dwpInteriorPaintCostPerSqft',
      'dwpBump2CostPerBoard',
      'dwpTrim2CostPerSqft',
      'dwpFinalPaintCostPerSqft',
      'dwpBump3CostPerBoard',
      'dwpCMBluetapeCostPerSqft',
      'dwpFinalBluetapeCostPerSqft',
      'interiorOptionsPercentage',
      'exteriorOptionsPercentage',
      'trimOptionPercentage',
    ]),
  )
  implements RegionUpdatableInterface {}
